import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios'
import { buildApiUrl } from '../config/api'

const LS_KEY = 'urbanai:selectedStore'

export const fetchStores = createAsyncThunk('location/fetchStores', async () => {
  const url = buildApiUrl('/api/v1/stores')
  const res = await axios.get(url)
  return res.data?.data || []
})

const persisted = (() => {
  try {
    const raw = localStorage.getItem(LS_KEY)
    return raw ? JSON.parse(raw) : null
  } catch (_) {
    return null
  }
})()

const initialState = {
  stores: [],
  selected: persisted, // { code, name, address, radiusKm, location }
  loading: false,
  error: null,
}

const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    setSelectedStore(state, action) {
      state.selected = action.payload
      try { localStorage.setItem(LS_KEY, JSON.stringify(action.payload)) } catch (_) {}
    },
    clearSelectedStore(state) {
      state.selected = null
      try { localStorage.removeItem(LS_KEY) } catch (_) {}
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStores.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchStores.fulfilled, (state, action) => {
        state.loading = false
        state.stores = action.payload
        // If nothing selected, default to HARARE when feature flag is on
        const flag = String(process.env.REACT_APP_MULTI_STORE_ENABLED || '').toLowerCase()
        const enabled = flag === 'true' || flag === '1' || flag === 'yes'
        if (enabled && !state.selected) {
          const def = action.payload.find((s) => s.code === 'HARARE') || action.payload[0] || null
          state.selected = def || null
          if (def) {
            try { localStorage.setItem(LS_KEY, JSON.stringify(def)) } catch (_) {}
          }
        }
      })
      .addCase(fetchStores.rejected, (state, action) => {
        state.loading = false
        state.error = action.error?.message || 'Failed to load stores'
      })
  }
})

export const { setSelectedStore, clearSelectedStore } = locationSlice.actions
export default locationSlice.reducer
